module.exports = __webpack_public_path__ + "img/4.b6030d10.png";